<template>
	<div>
		<div class="data41">
			<div class="data41Til">{{list.data.menuTitle}}</div>
			<div class="data41Box">
				<div class="data41BoxFor" v-for="(item,index) in list.data.cover" :key="index">
					<!-- <img :src="item" /> -->
					<img :src="item" v-if='list.data.type==2' :style="{
					width:'375px',
					height:'260px'
				}" />
					<img :src="item" v-else :style="{
					width:'375px',
					height:'375px'
				}" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list:[
				// 	{
				// 		img:require('@/assets/product/page10/lc1.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/lc2.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/lc3.png')
				// 	},
				// ]
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data41 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data41Til {
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 92px;
		}

		.data41Box {
			display: flex;
			align-items: center;
			overflow-x: auto;

			.data41BoxFor:not(:last-child) {
				margin-right: 30px;
			}

			.data41BoxFor {
				img {
					width: 375px;
					height: 375px;
					object-fit: contain;
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.data41{
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
			.data41Til{
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.data41BoxFor:not(:last-child) {
				margin-right: 4px !important;
			}
			.data41BoxFor {
				img {
					width: 100px !important;
					height:100px !important;
					object-fit: contain;
				}
			}
		}
	}
</style>